import { fetchEventSource } from "@microsoft/fetch-event-source";
import { ApiError, parseErrorDetail } from "@/api/fetch";

interface OpenStreamOptions {
  path: string;
  body: Record<string, unknown>;
  abortController: AbortController;
  getToken: () => Promise<string | null>;
  onMessage: (data: string) => void;
  onError: (error: unknown) => void;
  onClose: () => void;
  onAccepted?: () => void;
}

export const openStream = async ({
  path,
  body,
  abortController,
  getToken,
  onMessage,
  onError,
  onClose,
  onAccepted,
}: OpenStreamOptions): Promise<void> => {
  const token = await getToken();
  if (!token) {
    onError(new Error("Not signed in"));
    return;
  }

  await fetchEventSource(path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
    signal: abortController.signal,
    openWhenHidden: true,

    async onopen(response) {
      if (response.ok) {
        onAccepted?.();
        return;
      }
      throw new ApiError(await parseErrorDetail(response), response.status);
    },

    onmessage(event) {
      if (event.data) {
        onMessage(event.data);
      }
    },

    onerror(err) {
      if (abortController.signal.aborted) return;
      onError(err);
      throw err; // stop retrying
    },

    onclose() {
      onClose();
    },
  });
};
